module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "after-the-bombs-the-cavemen-1"
    }
  }, [_c('h1', [_vm._v("After the Bombs: The Cavemen")]), _vm._v(" "), _c('p', [_vm._v("As they watched from the safety of the trees, the cavemen saw Andrew and Mel come along on horseback. The cavemen did not fancy their chances with a horse none of them had ever ridden a horse before and they were more than a little afraid of them. Plus, the riders didn’t appear to have any food with them they so the cavemen had no interest in Andrew and Mel.")]), _vm._v(" "), _c('p', [_vm._v("Behind the trees where the cavemen hid, the River Calder ran between Calder City and Fort Calder.")]), _vm._v(" "), _c('p', [_vm._v("There were bushes near the river and they were covered in berries. The berries tasted fine and the cavemen stood picking and eating them.")]), _vm._v(" "), _c('p', [_vm._v("It wasn’t much of a meal but it was keeping them alive. While they were picking and eating berries, they did not see Jonah and Celeste arrive and talk to Andrew and Mel.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aecabf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch019.vue
// module id = 120
// module chunks = 0